<template>
  <div>
    <h3>Total Candidates: {{ pagination.totalItems }}</h3>

    <filters />

    <el-table
      class="cursor-pointer"
      border
      :data="candidatesData"
      highlight-current-row
      @row-click="handleClickRow"
    >
      <el-table-column
        width="64px"
        prop="activated"
        label="Active"
      >
        <template slot-scope="scope">
          <activated-icon :is-activated="scope.row.activated" />
        </template>
      </el-table-column>
      <el-table-column
        prop="firstName"
        label="First Name"
      >
        <template slot-scope="scope">
          {{ scope.row.firstName | NA }}
        </template>
      </el-table-column>
      <el-table-column
        prop="lastName"
        label="Last Name"
      >
        <template slot-scope="scope">
          {{ scope.row.lastName | NA }}
        </template>
      </el-table-column>
      <el-table-column
        prop="email"
        label="Email"
      />
      <el-table-column
        width="72px"
        prop="gender"
        label="Gender"
      >
        <template slot-scope="scope">
          <gender-icon :gender="scope.row.gender" />
        </template>
      </el-table-column>
      <el-table-column
        prop="profile.createdDate"
        label="Date Created"
      >
        <template slot-scope="scope">
          {{ displayDate(scope.row.createdDate) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="location.name"
        label="Location"
      >
        <template slot-scope="scope">
          {{ (scope.row.location && scope.row.location.name) | NA | ucwords }}
        </template>
      </el-table-column>
      <el-table-column
        prop="educationLevel"
        label="Education Level"
      >
        <template slot-scope="scope">
          {{ scope.row.educationLevel | NA | removeDashes | ucwords }}
        </template>
      </el-table-column>
      <el-table-column
        prop="birthInfo.year"
        label="Date of Birth"
      >
        <template slot-scope="scope">
          {{ birthDate(scope.row.birthInfo.day, scope.row.birthInfo.month, scope.row.birthInfo.year) }}
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="has-top-padding is-centered"
      background
      layout="prev, pager, next"
      :page-size="pagination.pageSize"
      :total="pagination.totalItems"
      @current-change="changePaginationPage"
    />

    <UserDrawer
      :show-panel="enablePanel"
      :user="currentRow"
      :is-recruiter="false"
      @close="handleClosePanel()"
    />
  </div>
</template>

<script>
import debounce from 'debounce-promise'
import Filters from '@/components/Filters/Filters'
import UserDrawer from '@/components/UserDrawer/UserDrawer'
import GenderIcon from '@/components/GenderIcon/GenderIcon'
import ActivatedIcon from '@/components/ActivatedIcon/ActivatedIcon'
import { GlobalEmitter } from '@/utils/GlobalEmitter'

export default {
  name: 'Candidates',
  components: {
    Filters,
    UserDrawer,
    GenderIcon,
    ActivatedIcon
  },
  data() {
    return {
      pagination: {
        currentPage: 1,
        pageSize: 12,
        totalItems: 0
      },
      enablePanel: false,
      currentRow: {}
    }
  },
  computed: {
    requestQueryParams() {
      return this.$store.getters['filters/requestQueryParams']
    },

    candidatesData() {
      return this.$store.getters.candidatesData
    }
  },
  watch: {
    requestQueryParams() {
      this.getCandidatesDebounce(this)
    }
  },
  async created() {
    GlobalEmitter.$on('resetView', async(dt) => {   
      this.pagination = {
        currentPage: 1,
        pageSize: 12,
        totalItems: 0
      }
      this.$store.commit("filters/reset")
    })

    GlobalEmitter.$on('reloadView', async(dt) => {
      await this.getCandidates()
    })
    await this.getCandidates()
  },
  methods: {
    handleClickRow(row) {
      this.currentRow = row
      this.enablePanel = true
    },

    handleClosePanel() {
      this.enablePanel = false
    },

    changePaginationPage(page) {
      this.pagination.currentPage = page
      this.getCandidates()
    },

    getCandidatesDebounce: debounce(vm => {
      vm.pagination.currentPage = 1
      vm.getCandidates()
    }, 400),

    getCandidates() {
      const params = {
        page: this.pagination.currentPage - 1,
        size: this.pagination.pageSize,
        ...this.requestQueryParams
      }

      this.$store.dispatch('getCandidates', { params })
        .then(res => {
          const pagination = this.$store.getters.candidatesPaginationData

          this.pagination.currentPage = pagination.currentPage
          this.pagination.totalItems = pagination.totalItems
        })
    }
  }
}
</script>
